import React, { Component } from 'react'
import { connect } from 'react-redux'

class GridSettings extends Component {

    constructor(props) {
        super(props)

        this.state = {
            grideSize: this.props.grideSize
        }
    }

    handleDataChange = (e) => {
        this.setState({
            grideSize: e.target.value
        })
    }

    handleSubmit = (e) => {
        e.preventDefault()
        this.props.handleGridSizeChange(this.state.grideSize)
    }


    render() {
        const { modalWidth, modalTitleStyle } = this.props;
        return (
            <div style={{ width: `${modalWidth}`}}>
                <br></br>
                <form>
                    <div className="form-group">
                        <label htmlFor="contentInput" style={modalTitleStyle}>Grid square size</label>
                        <input type="text" onChange={this.handleDataChange} className="form-control form-control-sm" id="contentInput" aria-describedby="contentHelp" value={this.state.gridSize} />
                    </div>
                    <hr></hr>
                    <button className="btn btn-dark btn-sm" onClick={this.handleSubmit}>Adjust</button>
                </form>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        themeColors: state.theme,
        formLabelStyle: state.appControl.formLabelStyle,
        modalWidth: state.appControl.modalWidth,
        modalTitleStyle: state.appControl.modalTitleStyle,
    }
}

export default connect(mapStateToProps)(GridSettings);